import React, { PureComponent } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { CloakFileQR /*, AppStr*/ } from 'cloak-file-sdk-web'
import CloakSnackBar from '../components/ui/CloakSnackBar'
import { isAndroid, isIOS } from "react-device-detect";

import { styled } from '@mui/system';

/*var forge = require('node-forge');
var openpgp = require('openpgp')*/

const StyledLink = styled('a')({
	color: '#1aa3ff',
	textDecoration: 'underline',
	transition: 'color 0.2s ease',
	'&:hover': {
		color: '#1792e5',
		'@media (hover: none)': {
			color: '#1792e5',
		},
	},
});

const StyledLink2 = styled('a')({
	color: '#606060',
	textDecoration: 'none',
	transition: 'color 0.2s ease',
	'&:hover': {
		color: '#000000',
		'@media (hover: none)': {
			color: '#606060',
		},
	},
});

class QRCloakingPage extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			showSnackBar: true
		}

		this.closeSnackBar = this.closeSnackBar.bind(this)
	}

	closeSnackBar() {
		this.setState({ showSnackBar: false })
	}

	render() {
		const { redirect, isUser } = this.props;

		var downloadLink = "https://www.cloakapps.com/cloak.html#download"
		if (isAndroid) {
			downloadLink = "https://play.google.com/store/apps/details?id=com.cloakapps.cloak"
		} else if (isIOS) {
			downloadLink = "https://apps.apple.com/us/app/cloak-encrypt/id1495943745"
		}

		if (redirect) {
			if (isUser) {
				return <Navigate to="/cloak/login" />
			} else {
				return <Navigate to="/cloak/signup" />
			}
		}

		return (
			<div className="clk-primary-qr-div">
				{
					this.state.showSnackBar &&
					<CloakSnackBar>
						<div id="link-container">
							<span id="spacer"></span>
							<StyledLink href={downloadLink} target="_blank" rel="noopener noreferrer">
								<FormattedMessage id="cloak.appDwnld" />
							</StyledLink>
							<span id="spacer"></span>
							<StyledLink2 href="#" onClick={this.closeSnackBar}>x</StyledLink2>
						</div>
					</CloakSnackBar>
				}
				<div className="clk-primary-qr clk-box-shadow ">
					<div>
						<CloakFileQR />
					</div>
					<div style={{ fontSize: 10, textAlign: 'center', color: '#a6a6a6', marginTop: 30 }}>
						<NavLink to="https://youtu.be/jByJ221Gi2Y" style={{ color: '#000' }}>
							<FormattedMessage id="cloak.learnMoreAbtQLink" />
						</NavLink>
					</div>
				</div>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		redirect: state.cloak.redirect,
		isUser: state.cloak.isUser,
		token: state.auth.token
	}
};

//const StyledQRCloakingPage = styled(QRCloakingPage)(styles);
export default connect(mapStateToProps)(QRCloakingPage);
